import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const StrikeThrough01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 16C6 18.2091 7.79086 20 10 20H14C16.2091 20 18 18.2091 18 16C18 13.7909 16.2091 12 14 12M18 8C18 5.79086 16.2091 4 14 4H10C7.79086 4 6 5.79086 6 8M3 12H21"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Bold01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 12H14C16.2091 12 18 10.2091 18 8C18 5.79086 16.2091 4 14 4H6V12ZM6 12H15C17.2091 12 19 13.7909 19 16C19 18.2091 17.2091 20 15 20H6V12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Italic01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M19 4H10M14 20H5M15 4L9 20" className="fill-none stroke-current" />
  </svg>
);

export const Underline01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 4V11C18 14.3137 15.3137 17 12 17C8.68629 17 6 14.3137 6 11V4M4 21H20"
      className="fill-none stroke-current"
    />
  </svg>
);

export const MagicWand01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3.13146 20.1314C2.73545 19.7354 2.53744 19.5373 2.46325 19.309C2.39799 19.1082 2.39799 18.8918 2.46325 18.691C2.53744 18.4627 2.73545 18.2646 3.13146 17.8686L10.0001 11L13.0001 14L6.13146 20.8686C5.73545 21.2646 5.53744 21.4627 5.30911 21.5368C5.10827 21.6021 4.89192 21.6021 4.69108 21.5368C4.46275 21.4627 4.26474 21.2646 3.86872 20.8686L3.13146 20.1314Z"
      className="fill-current opacity-12"
    />
    <path
      d="M13.0001 14L10.0001 11M15.0104 3.5V2M18.9498 5.06066L20.0104 4M18.9498 13L20.0104 14.0607M11.0104 5.06066L9.94979 4M20.5104 9H22.0104M6.13146 20.8686L15.3687 11.6314C15.7647 11.2354 15.9627 11.0373 16.0369 10.809C16.1022 10.6082 16.1022 10.3918 16.0369 10.191C15.9627 9.96265 15.7647 9.76465 15.3687 9.36863L14.6315 8.63137C14.2354 8.23535 14.0374 8.03735 13.8091 7.96316C13.6083 7.8979 13.3919 7.8979 13.1911 7.96316C12.9627 8.03735 12.7647 8.23535 12.3687 8.63137L3.13146 17.8686C2.73545 18.2646 2.53744 18.4627 2.46325 18.691C2.39799 18.8918 2.39799 19.1082 2.46325 19.309C2.53744 19.5373 2.73545 19.7354 3.13146 20.1314L3.86872 20.8686C4.26474 21.2646 4.46275 21.4627 4.69108 21.5368C4.89192 21.6021 5.10827 21.6021 5.30911 21.5368C5.53744 21.4627 5.73545 21.2646 6.13146 20.8686Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Wand = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3.13134 20.1314C2.73533 19.7354 2.53732 19.5373 2.46313 19.309C2.39787 19.1082 2.39787 18.8918 2.46313 18.691C2.53732 18.4627 2.73532 18.2646 3.13134 17.8686L9.99997 11L13 14L6.13134 20.8686C5.73532 21.2646 5.53732 21.4627 5.30899 21.5368C5.10814 21.6021 4.8918 21.6021 4.69095 21.5368C4.46263 21.4627 4.26462 21.2646 3.8686 20.8686L3.13134 20.1314Z"
      className="fill-current opacity-12"
    />
    <path
      d="M13 14L9.99997 11M15.0103 3.5V2M18.9497 5.06066L20.0103 4M18.9497 13L20.0103 14.0607M11.0103 5.06066L9.94966 4M20.5103 9H22.0103M6.13134 20.8686L15.3686 11.6314C15.7646 11.2354 15.9626 11.0373 16.0368 10.809C16.1021 10.6082 16.1021 10.3918 16.0368 10.191C15.9626 9.96265 15.7646 9.76465 15.3686 9.36863L14.6313 8.63137C14.2353 8.23535 14.0373 8.03735 13.809 7.96316C13.6081 7.8979 13.3918 7.8979 13.191 7.96316C12.9626 8.03735 12.7646 8.23535 12.3686 8.63137L3.13134 17.8686C2.73532 18.2646 2.53732 18.4627 2.46313 18.691C2.39787 18.8918 2.39787 19.1082 2.46313 19.309C2.53732 19.5373 2.73533 19.7354 3.13134 20.1314L3.8686 20.8686C4.26462 21.2646 4.46263 21.4627 4.69095 21.5368C4.8918 21.6021 5.10814 21.6021 5.30899 21.5368C5.53732 21.4627 5.73533 21.2646 6.13134 20.8686Z"
      className="fill-none stroke-current"
    />
  </svg>
);
export const Sparkle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 3L13.9389 9.50614L20.5 11.5L13.9389 13.4939L12 20L10.0611 13.4939L3.5 11.5L10.0611 9.50614L12 3Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 3L13.9389 9.50614L20.5 11.5L13.9389 13.4939L12 20L10.0611 13.4939L3.5 11.5L10.0611 9.50614L12 3Z M18 4L18.5 5.5L20 6L18.5 6.5L18 8L17.5 6.5L16 6L17.5 5.5L18 4Z M6 16L6.5 17.5L8 18L6.5 18.5L6 20L5.5 18.5L4 18L5.5 17.5L6 16Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const TextInput = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M18.8 7H17V17H18.8C19.9201 17 20.4802 17 20.908 16.782C21.2843 16.5903 21.5903 16.2843 21.782 15.908C22 15.4802 22 14.9201 22 13.8V10.2C22 9.0799 22 8.51984 21.782 8.09202C21.5903 7.71569 21.2843 7.40973 20.908 7.21799C20.4802 7 19.9201 7 18.8 7Z"
      className="fill-current opacity-12"
    />
    <path
      d="M13 7H5.2C4.0799 7 3.51984 7 3.09202 7.21799C2.71569 7.40973 2.40973 7.71569 2.21799 8.09202C2 8.51984 2 9.0799 2 10.2V13.8C2 14.9201 2 15.4802 2.21799 15.908C2.40973 16.2843 2.71569 16.5903 3.09202 16.782C3.51984 17 4.07989 17 5.2 17H13M17 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.0799 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H17M17 21L17 3M19.5 3.00001L14.5 3M19.5 21L14.5 21"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Colors = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M13.5798 13.7899C13.0765 13.9269 12.5468 14 12 14C9.46679 14 7.30024 12.4302 6.42018 10.2102C3.87293 10.9036 2 13.2331 2 16C2 19.3138 4.68629 22 8 22C11.3137 22 14 19.3138 14 16C14 15.2195 13.851 14.4739 13.5798 13.7899Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 20.4722C13.0615 21.4223 14.4633 22 16 22C19.3137 22 22 19.3137 22 16C22 13.2331 20.1271 10.9036 17.5798 10.2102M6.42018 10.2102C3.87293 10.9036 2 13.2331 2 16C2 19.3137 4.68629 22 8 22C11.3137 22 14 19.3137 14 16C14 15.2195 13.851 14.4738 13.5798 13.7898M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Dotpoints01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 12L9 12M21 6L9 6M21 18L9 18M5 12C5 12.5523 4.55228 13 4 13C3.44772 13 3 12.5523 3 12C3 11.4477 3.44772 11 4 11C4.55228 11 5 11.4477 5 12ZM5 6C5 6.55228 4.55228 7 4 7C3.44772 7 3 6.55228 3 6C3 5.44772 3.44772 5 4 5C4.55228 5 5 5.44772 5 6ZM5 18C5 18.5523 4.55228 19 4 19C3.44772 19 3 18.5523 3 18C3 17.4477 3.44772 17 4 17C4.55228 17 5 17.4477 5 18Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Pencil01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.55809 16.1488C4.70537 15.7659 4.77901 15.5745 4.90531 15.4868C5.01569 15.4101 5.15228 15.3811 5.28427 15.4063C5.43531 15.4352 5.58036 15.5802 5.87046 15.8703L8.12955 18.1294C8.41964 18.4195 8.56469 18.5646 8.59354 18.7156C8.61874 18.8476 8.58976 18.9842 8.51312 19.0946C8.42542 19.2209 8.23396 19.2945 7.85104 19.4418L2.5 21.4999L4.55809 16.1488Z"
      className="fill-current opacity-12"
    />
    <path
      d="M2.5 21.4998L8.04927 19.3655C8.40421 19.229 8.58168 19.1607 8.74772 19.0716C8.8952 18.9924 9.0358 18.901 9.16804 18.7984C9.31692 18.6829 9.45137 18.5484 9.72028 18.2795L21 6.99982C22.1046 5.89525 22.1046 4.10438 21 2.99981C19.8955 1.89525 18.1046 1.89524 17 2.99981L5.72028 14.2795C5.45138 14.5484 5.31692 14.6829 5.20139 14.8318C5.09877 14.964 5.0074 15.1046 4.92823 15.2521C4.83911 15.4181 4.77085 15.5956 4.63433 15.9506L2.5 21.4998ZM2.5 21.4998L4.55812 16.1488C4.7054 15.7659 4.77903 15.5744 4.90534 15.4867C5.01572 15.4101 5.1523 15.3811 5.2843 15.4063C5.43533 15.4351 5.58038 15.5802 5.87048 15.8703L8.12957 18.1294C8.41967 18.4195 8.56472 18.5645 8.59356 18.7155C8.61877 18.8475 8.58979 18.9841 8.51314 19.0945C8.42545 19.2208 8.23399 19.2944 7.85107 19.4417L2.5 21.4998Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Pencil03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.87604 18.1156C2.92198 17.7021 2.94496 17.4954 3.00751 17.3022C3.06301 17.1307 3.14143 16.9676 3.24064 16.8171C3.35246 16.6475 3.49955 16.5005 3.79373 16.2063L17 3C18.1046 1.89543 19.8955 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.79373 20.2063C7.49955 20.5005 7.35245 20.6475 7.18289 20.7594C7.03245 20.8586 6.86929 20.937 6.69785 20.9925C6.5046 21.055 6.29786 21.078 5.88437 21.124L2.5 21.5L2.87604 18.1156Z"
      className="fill-current opacity-12"
    />
    <path
      d="M2.87604 18.1156C2.92198 17.7021 2.94496 17.4954 3.00751 17.3022C3.06301 17.1307 3.14143 16.9676 3.24064 16.8171C3.35246 16.6475 3.49955 16.5005 3.79373 16.2063L17 3C18.1046 1.89543 19.8955 1.89543 21 3C22.1046 4.10457 22.1046 5.89543 21 7L7.79373 20.2063C7.49955 20.5005 7.35245 20.6475 7.18289 20.7594C7.03245 20.8586 6.86929 20.937 6.69785 20.9925C6.5046 21.055 6.29786 21.078 5.88437 21.124L2.5 21.5L2.87604 18.1156Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const TypeSquare = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H16.2C17.8802 3 18.7202 3 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C21 5.27976 21 6.11984 21 7.8V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H7.8C6.11984 21 5.27976 21 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3 18.7202 3 17.8802 3 16.2V7.8Z"
      className="fill-current opacity-12"
    />
    <path
      d="M8 7H16M12 7V17M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Type01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M9 20H15M12 4V20"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Type02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path d="M10.25 20V4H13.75V20H10.25Z" className="fill-current opacity-12" />
    <path
      d="M4 7C4 6.06812 4 5.60218 4.15224 5.23463C4.35523 4.74458 4.74458 4.35523 5.23463 4.15224C5.60218 4 6.06812 4 7 4H17C17.9319 4 18.3978 4 18.7654 4.15224C19.2554 4.35523 19.6448 4.74458 19.8478 5.23463C20 5.60218 20 6.06812 20 7M8 20H16M10.25 4V20M13.75 4V20"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PenTool02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.1314 10.8686C19.7354 11.2646 19.5373 11.4626 19.309 11.5368C19.1082 11.6021 18.8918 11.6021 18.691 11.5368C18.4627 11.4626 18.2646 11.2646 17.8686 10.8686L13.1314 6.13134C12.7354 5.73532 12.5373 5.53732 12.4632 5.30899C12.3979 5.10814 12.3979 4.8918 12.4632 4.69095C12.5373 4.46263 12.7354 4.26462 13.1314 3.8686L13.8686 3.13134C14.2646 2.73533 14.4627 2.53732 14.691 2.46313C14.8918 2.39787 15.1082 2.39787 15.309 2.46313C15.5373 2.53732 15.7354 2.73532 16.1314 3.13134L20.8686 7.8686C21.2646 8.26462 21.4627 8.46263 21.5368 8.69095C21.6021 8.8918 21.6021 9.10814 21.5368 9.30899C21.4627 9.53732 21.2646 9.73532 20.8686 10.1313L20.1314 10.8686Z"
      className="fill-current opacity-12"
    />
    <path
      d="M13 13C13 11.8954 12.1046 11 11 11C9.89543 11 9 11.8954 9 13C9 14.1045 9.89543 15 11 15C12.1046 15 13 14.1045 13 13Z"
      className="fill-current opacity-12"
    />
    <path
      d="M13 5.99997L6.50182 7.29961C6.13883 7.37221 5.95733 7.40851 5.80952 7.49677C5.67886 7.57481 5.56772 7.68164 5.4846 7.80913C5.39057 7.95334 5.34714 8.13326 5.26028 8.49311L2 22M2 22L15.5069 18.7397C15.8667 18.6528 16.0466 18.6094 16.1908 18.5154C16.3183 18.4322 16.4252 18.3211 16.5032 18.1904C16.5915 18.0426 16.6278 17.8611 16.7004 17.4981L18 11M2 22L9.586 14.414M20.8686 7.8686L16.1314 3.13134C15.7354 2.73532 15.5373 2.53732 15.309 2.46313C15.1082 2.39787 14.8918 2.39787 14.691 2.46313C14.4627 2.53732 14.2646 2.73533 13.8686 3.13134L13.1314 3.8686C12.7354 4.26462 12.5373 4.46263 12.4632 4.69095C12.3979 4.8918 12.3979 5.10814 12.4632 5.30899C12.5373 5.53732 12.7354 5.73532 13.1314 6.13134L17.8686 10.8686C18.2646 11.2646 18.4627 11.4626 18.691 11.5368C18.8918 11.6021 19.1082 11.6021 19.309 11.5368C19.5373 11.4626 19.7354 11.2646 20.1314 10.8686L20.8686 10.1313C21.2646 9.73532 21.4627 9.53732 21.5368 9.30899C21.6021 9.10814 21.6021 8.8918 21.5368 8.69095C21.4627 8.46263 21.2646 8.26462 20.8686 7.8686ZM11 11C12.1046 11 13 11.8954 13 13C13 14.1045 12.1046 15 11 15C9.89543 15 9 14.1045 9 13C9 11.8954 9.89543 11 11 11Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const CursorClick01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.817 13.3728C21.3457 13.0881 21.61 12.9458 21.6768 12.7746C21.7349 12.626 21.7185 12.4586 21.6328 12.324C21.534 12.169 21.2471 12.0806 20.6733 11.9039L9.44528 8.44522C8.97653 8.30083 8.74216 8.22863 8.58386 8.28672C8.44598 8.33732 8.33732 8.44598 8.28672 8.58386C8.22863 8.74216 8.30083 8.97653 8.44522 9.44528L11.9038 20.6733C12.0806 21.2471 12.169 21.534 12.324 21.6328C12.4585 21.7185 12.6259 21.7349 12.7745 21.6769C12.9458 21.61 13.0881 21.3457 13.3728 20.8171L15.8645 16.1896C15.9068 16.111 15.928 16.0718 15.9551 16.0374C15.9793 16.0069 16.0069 15.9793 16.0374 15.9551C16.0718 15.928 16.111 15.9068 16.1896 15.8645L20.817 13.3728Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9 3.5V2M5.06066 5.06066L4 4M5.06066 13L4 14.0607M13 5.06066L14.0607 4M3.5 9H2M15.8645 16.1896L13.3727 20.817C13.0881 21.3457 12.9457 21.61 12.7745 21.6769C12.6259 21.7349 12.4585 21.7185 12.324 21.6328C12.1689 21.534 12.0806 21.2471 11.9038 20.6733L8.44519 9.44525C8.3008 8.97651 8.2286 8.74213 8.28669 8.58383C8.33729 8.44595 8.44595 8.33729 8.58383 8.2867C8.74213 8.22861 8.9765 8.3008 9.44525 8.44519L20.6732 11.9038C21.247 12.0806 21.5339 12.169 21.6327 12.324C21.7185 12.4586 21.7348 12.6259 21.6768 12.7745C21.61 12.9458 21.3456 13.0881 20.817 13.3728L16.1896 15.8645C16.111 15.9068 16.0717 15.9279 16.0374 15.9551C16.0068 15.9792 15.9792 16.0068 15.9551 16.0374C15.9279 16.0717 15.9068 16.111 15.8645 16.1896Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Cursor02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M20.5054 10.7756C21.1223 10.5357 21.4308 10.4157 21.5174 10.2461C21.5924 10.0992 21.5901 9.9247 21.5112 9.77978C21.4202 9.61251 21.1087 9.50069 20.4857 9.27705L4.59605 3.57305C4.08635 3.39008 3.8315 3.29859 3.6649 3.35629C3.52005 3.40645 3.40621 3.52029 3.35605 3.66514C3.29835 3.83175 3.38983 4.08659 3.5728 4.59629L9.27675 20.486C9.50039 21.109 9.61221 21.4205 9.77949 21.5115C9.92441 21.5904 10.0989 21.5927 10.2458 21.5176C10.4154 21.431 10.5354 21.1226 10.7753 20.5057L13.3722 13.8281C13.4191 13.7072 13.4426 13.6468 13.4789 13.5959C13.5111 13.5508 13.5505 13.5114 13.5956 13.4792C13.6465 13.4429 13.7069 13.4194 13.8278 13.3724L20.5054 10.7756Z"
      className="fill-current opacity-12"
    />
    <path
      d="M20.5056 10.7756C21.1225 10.5357 21.431 10.4157 21.5176 10.2461C21.5926 10.0992 21.5903 9.9247 21.5115 9.77978C21.4205 9.61251 21.109 9.50069 20.486 9.27705L4.59629 3.57305C4.0866 3.39008 3.83175 3.29859 3.66514 3.35629C3.52029 3.40645 3.40645 3.52029 3.35629 3.66514C3.29859 3.83175 3.39008 4.08659 3.57304 4.59629L9.277 20.486C9.50064 21.109 9.61246 21.4205 9.77973 21.5115C9.92465 21.5904 10.0991 21.5927 10.2461 21.5176C10.4157 21.431 10.5356 21.1226 10.7756 20.5057L13.3724 13.8281C13.4194 13.7072 13.4429 13.6468 13.4792 13.5959C13.5114 13.5508 13.5508 13.5114 13.5959 13.4792C13.6468 13.4429 13.7072 13.4194 13.828 13.3724L20.5056 10.7756Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ZoomOut = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21 21L16.65 16.65M8 11H14M19 11C19 15.4183 15.4183 19 11 19C6.58172 19 3 15.4183 3 11C3 6.58172 6.58172 3 11 3C15.4183 3 19 6.58172 19 11Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const Hand = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111V4.77778C17.1 3.8573 16.3389 3.11111 15.4 3.11111C14.4611 3.11111 13.7 3.8573 13.7 4.77778V3.66667C13.7 2.74619 12.9389 2 12 2C11.0611 2 10.3 2.74619 10.3 3.66667V4.77778C10.3 3.8573 9.53888 3.11111 8.6 3.11111C7.66112 3.11111 6.9 3.8573 6.9 4.77778V11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M6.9 11.4444V14.2222M6.9 11.4444V4.77778C6.9 3.8573 7.66112 3.11111 8.6 3.11111C9.53888 3.11111 10.3 3.8573 10.3 4.77778M6.9 11.4444C6.9 10.524 6.13888 9.77778 5.2 9.77778C4.26112 9.77778 3.5 10.524 3.5 11.4444V13.6667C3.5 18.269 7.30558 22 12 22C16.6944 22 20.5 18.269 20.5 13.6667V8.11111C20.5 7.19064 19.7389 6.44444 18.8 6.44444C17.8611 6.44444 17.1 7.19064 17.1 8.11111M10.3 4.77778V10.8889M10.3 4.77778V3.66667C10.3 2.74619 11.0611 2 12 2C12.9389 2 13.7 2.74619 13.7 3.66667V4.77778M13.7 4.77778V10.8889M13.7 4.77778C13.7 3.8573 14.4611 3.11111 15.4 3.11111C16.3389 3.11111 17.1 3.8573 17.1 4.77778V8.11111M17.1 8.11111V10.8889"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const Scissors01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 6C9 4.34315 7.65685 3 6 3C4.34315 3 3 4.34315 3 6C3 7.65685 4.34315 9 6 9C7.65685 9 9 7.65685 9 6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9 18C9 16.3431 7.65685 15 6 15C4.34315 15 3 16.3431 3 18C3 19.6569 4.34315 21 6 21C7.65685 21 9 19.6569 9 18Z"
      className="fill-current opacity-12"
    />

    <path
      d="M20 4L8.5 15.5M8.5 8.5L20 20M6 3C7.65685 3 9 4.34315 9 6C9 7.65685 7.65685 9 6 9C4.34315 9 3 7.65685 3 6C3 4.34315 4.34315 3 6 3ZM6 15C7.65685 15 9 16.3431 9 18C9 19.6569 7.65685 21 6 21C4.34315 21 3 19.6569 3 18C3 16.3431 4.34315 15 6 15Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const Transform = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 4.6C3 4.03995 3 3.75992 3.10899 3.54601C3.20487 3.35785 3.35785 3.20487 3.54601 3.10899C3.75992 3 4.03995 3 4.6 3H5.4C5.96005 3 6.24008 3 6.45399 3.10899C6.64215 3.20487 6.79513 3.35785 6.89101 3.54601C7 3.75992 7 4.03995 7 4.6V5.4C7 5.96005 7 6.24008 6.89101 6.45399C6.79513 6.64215 6.64215 6.79513 6.45399 6.89101C6.24008 7 5.96005 7 5.4 7H4.6C4.03995 7 3.75992 7 3.54601 6.89101C3.35785 6.79513 3.20487 6.64215 3.10899 6.45399C3 6.24008 3 5.96005 3 5.4V4.6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M3 18.6C3 18.0399 3 17.7599 3.10899 17.546C3.20487 17.3578 3.35785 17.2049 3.54601 17.109C3.75992 17 4.03995 17 4.6 17H5.4C5.96005 17 6.24008 17 6.45399 17.109C6.64215 17.2049 6.79513 17.3578 6.89101 17.546C7 17.7599 7 18.0399 7 18.6V19.4C7 19.9601 7 20.2401 6.89101 20.454C6.79513 20.6422 6.64215 20.7951 6.45399 20.891C6.24008 21 5.96005 21 5.4 21H4.6C4.03995 21 3.75992 21 3.54601 20.891C3.35785 20.7951 3.20487 20.6422 3.10899 20.454C3 20.2401 3 19.9601 3 19.4V18.6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M17 4.6C17 4.03995 17 3.75992 17.109 3.54601C17.2049 3.35785 17.3578 3.20487 17.546 3.10899C17.7599 3 18.0399 3 18.6 3H19.4C19.9601 3 20.2401 3 20.454 3.10899C20.6422 3.20487 20.7951 3.35785 20.891 3.54601C21 3.75992 21 4.03995 21 4.6V5.4C21 5.96005 21 6.24008 20.891 6.45399C20.7951 6.64215 20.6422 6.79513 20.454 6.89101C20.2401 7 19.9601 7 19.4 7H18.6C18.0399 7 17.7599 7 17.546 6.89101C17.3578 6.79513 17.2049 6.64215 17.109 6.45399C17 6.24008 17 5.96005 17 5.4V4.6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M17 18.6C17 18.0399 17 17.7599 17.109 17.546C17.2049 17.3578 17.3578 17.2049 17.546 17.109C17.7599 17 18.0399 17 18.6 17H19.4C19.9601 17 20.2401 17 20.454 17.109C20.6422 17.2049 20.7951 17.3578 20.891 17.546C21 17.7599 21 18.0399 21 18.6V19.4C21 19.9601 21 20.2401 20.891 20.454C20.7951 20.6422 20.6422 20.7951 20.454 20.891C20.2401 21 19.9601 21 19.4 21H18.6C18.0399 21 17.7599 21 17.546 20.891C17.3578 20.7951 17.2049 20.6422 17.109 20.454C17 20.2401 17 19.9601 17 19.4V18.6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M19 7V17M5 7V17M17 5L7 5M17 19H7M4.6 7H5.4C5.96005 7 6.24008 7 6.45399 6.89101C6.64215 6.79513 6.79513 6.64215 6.89101 6.45399C7 6.24008 7 5.96005 7 5.4V4.6C7 4.03995 7 3.75992 6.89101 3.54601C6.79513 3.35785 6.64215 3.20487 6.45399 3.10899C6.24008 3 5.96005 3 5.4 3H4.6C4.03995 3 3.75992 3 3.54601 3.10899C3.35785 3.20487 3.20487 3.35785 3.10899 3.54601C3 3.75992 3 4.03995 3 4.6V5.4C3 5.96005 3 6.24008 3.10899 6.45399C3.20487 6.64215 3.35785 6.79513 3.54601 6.89101C3.75992 7 4.03995 7 4.6 7ZM4.6 21H5.4C5.96005 21 6.24008 21 6.45399 20.891C6.64215 20.7951 6.79513 20.6422 6.89101 20.454C7 20.2401 7 19.9601 7 19.4V18.6C7 18.0399 7 17.7599 6.89101 17.546C6.79513 17.3578 6.64215 17.2049 6.45399 17.109C6.24008 17 5.96005 17 5.4 17H4.6C4.03995 17 3.75992 17 3.54601 17.109C3.35785 17.2049 3.20487 17.3578 3.10899 17.546C3 17.7599 3 18.0399 3 18.6V19.4C3 19.9601 3 20.2401 3.10899 20.454C3.20487 20.6422 3.35785 20.7951 3.54601 20.891C3.75992 21 4.03995 21 4.6 21ZM18.6 7H19.4C19.9601 7 20.2401 7 20.454 6.89101C20.6422 6.79513 20.7951 6.64215 20.891 6.45399C21 6.24008 21 5.96005 21 5.4V4.6C21 4.03995 21 3.75992 20.891 3.54601C20.7951 3.35785 20.6422 3.20487 20.454 3.10899C20.2401 3 19.9601 3 19.4 3H18.6C18.0399 3 17.7599 3 17.546 3.10899C17.3578 3.20487 17.2049 3.35785 17.109 3.54601C17 3.75992 17 4.03995 17 4.6V5.4C17 5.96005 17 6.24008 17.109 6.45399C17.2049 6.64215 17.3578 6.79513 17.546 6.89101C17.7599 7 18.0399 7 18.6 7ZM18.6 21H19.4C19.9601 21 20.2401 21 20.454 20.891C20.6422 20.7951 20.7951 20.6422 20.891 20.454C21 20.2401 21 19.9601 21 19.4V18.6C21 18.0399 21 17.7599 20.891 17.546C20.7951 17.3578 20.6422 17.2049 20.454 17.109C20.2401 17 19.9601 17 19.4 17H18.6C18.0399 17 17.7599 17 17.546 17.109C17.3578 17.2049 17.2049 17.3578 17.109 17.546C17 17.7599 17 18.0399 17 18.6V19.4C17 19.9601 17 20.2401 17.109 20.454C17.2049 20.6422 17.3578 20.7951 17.546 20.891C17.7599 21 18.0399 21 18.6 21Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const Reflect01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2 15.3754C2 15.8972 2 16.1581 2.10745 16.2943C2.20094 16.4128 2.34295 16.4827 2.49387 16.4846C2.66735 16.4867 2.87415 16.3276 3.28777 16.0095L7.67567 12.6342C7.95617 12.4184 8.09641 12.3105 8.14681 12.179C8.19098 12.0638 8.19098 11.9363 8.14681 11.8211C8.09641 11.6896 7.95617 11.5817 7.67567 11.366L3.28777 7.99065C2.87415 7.67248 2.66735 7.5134 2.49387 7.51552C2.34295 7.51737 2.20094 7.5873 2.10745 7.7058C2 7.842 2 8.10292 2 8.62475V15.3754Z"
      className="fill-current opacity-12"
    />
    <path
      d="M22 15.3754C22 15.8972 22 16.1581 21.8925 16.2943C21.7991 16.4128 21.6571 16.4827 21.5061 16.4846C21.3327 16.4867 21.1258 16.3276 20.7122 16.0095L16.3243 12.6342C16.0438 12.4184 15.9036 12.3105 15.8532 12.179C15.809 12.0638 15.809 11.9363 15.8532 11.8211C15.9036 11.6896 16.0438 11.5817 16.3243 11.366L20.7122 7.99065C21.1258 7.67248 21.3327 7.5134 21.5061 7.51552C21.6571 7.51737 21.7991 7.5873 21.8925 7.7058C22 7.842 22 8.10292 22 8.62475V15.3754Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 3V6M12 10.5V13.5M12 18V21M3.28777 7.99059L7.67567 11.3659C7.95617 11.5817 8.09641 11.6895 8.14681 11.821C8.19098 11.9363 8.19098 12.0637 8.14681 12.179C8.09641 12.3105 7.95617 12.4183 7.67567 12.6341L3.28777 16.0094C2.87415 16.3276 2.66735 16.4867 2.49387 16.4845C2.34295 16.4827 2.20094 16.4128 2.10745 16.2943C2 16.1581 2 15.8971 2 15.3753V8.62469C2 8.10286 2 7.84195 2.10745 7.70574C2.20094 7.58724 2.34295 7.51732 2.49387 7.51547C2.66735 7.51334 2.87415 7.67243 3.28777 7.99059ZM20.7122 7.99059L16.3243 11.3659C16.0438 11.5817 15.9036 11.6895 15.8532 11.821C15.809 11.9363 15.809 12.0637 15.8532 12.179C15.9036 12.3105 16.0438 12.4183 16.3243 12.6341L20.7122 16.0094C21.1258 16.3276 21.3327 16.4867 21.5061 16.4845C21.6571 16.4827 21.7991 16.4128 21.8925 16.2943C22 16.1581 22 15.8971 22 15.3753V8.62469C22 8.10286 22 7.84195 21.8925 7.70574C21.7991 7.58724 21.6571 7.51732 21.5061 7.51547C21.3327 7.51334 21.1258 7.67243 20.7122 7.99059Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const ReflectV01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15.3754 22C15.8972 22 16.1581 22 16.2943 21.8925C16.4128 21.7991 16.4827 21.657 16.4846 21.5061C16.4867 21.3327 16.3276 21.1258 16.0095 20.7122L12.6342 16.3243C12.4184 16.0438 12.3105 15.9036 12.179 15.8532C12.0638 15.809 11.9363 15.809 11.8211 15.8532C11.6896 15.9036 11.5817 16.0438 11.366 16.3243L7.99065 20.7122C7.67248 21.1258 7.5134 21.3327 7.51552 21.5061C7.51737 21.657 7.5873 21.7991 7.7058 21.8925C7.842 22 8.10292 22 8.62475 22H15.3754Z"
      className="fill-current opacity-12"
    />
    <path
      d="M15.3754 2C15.8972 2 16.1581 2 16.2943 2.10745C16.4128 2.20094 16.4827 2.34295 16.4846 2.49387C16.4867 2.66735 16.3276 2.87415 16.0095 3.28777L12.6342 7.67567C12.4184 7.95616 12.3105 8.09641 12.179 8.14682C12.0638 8.19098 11.9363 8.19098 11.8211 8.14682C11.6896 8.09641 11.5817 7.95616 11.366 7.67567L7.99065 3.28777C7.67248 2.87415 7.5134 2.66735 7.51552 2.49387C7.51737 2.34295 7.5873 2.20094 7.7058 2.10745C7.842 2 8.10292 2 8.62475 2H15.3754Z"
      className="fill-current opacity-12"
    />

    <path
      d="M3 12H6M10.5 12H13.5M18 12H21M7.99059 20.7122L11.3659 16.3243C11.5817 16.0438 11.6895 15.9036 11.821 15.8532C11.9363 15.809 12.0637 15.809 12.179 15.8532C12.3105 15.9036 12.4183 16.0438 12.6341 16.3243L16.0094 20.7122C16.3276 21.1258 16.4867 21.3327 16.4845 21.5061C16.4827 21.657 16.4128 21.7991 16.2943 21.8925C16.1581 22 15.8971 22 15.3753 22H8.62469C8.10286 22 7.84195 22 7.70574 21.8925C7.58724 21.7991 7.51732 21.657 7.51547 21.5061C7.51334 21.3327 7.67243 21.1258 7.99059 20.7122ZM7.99059 3.28777L11.3659 7.67567C11.5817 7.95616 11.6895 8.09641 11.821 8.14682C11.9363 8.19098 12.0637 8.19098 12.179 8.14682C12.3105 8.09641 12.4183 7.95616 12.6341 7.67567L16.0094 3.28777C16.3276 2.87415 16.4867 2.66735 16.4845 2.49387C16.4827 2.34295 16.4128 2.20094 16.2943 2.10745C16.1581 2 15.8971 2 15.3753 2H8.62469C8.10286 2 7.84195 2 7.70574 2.10745C7.58724 2.20094 7.51732 2.34295 7.51547 2.49387C7.51334 2.66735 7.67243 2.87415 7.99059 3.28777Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);

export const Bold02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 4v16M9.5 4h6a4 4 0 0 1 0 8h-6 7a4 4 0 0 1 0 8h-7m0-16v16m0-16H4m5.5 16H4"
      className="fill-none stroke-current"
    />
  </svg>
);

export const BoldSquare = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M8.5 12H13a2.5 2.5 0 0 0 0-5H8.5v5Zm0 0H14a2.5 2.5 0 0 1 0 5H8.5v-5Zm-.7 9h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Italic02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m13.25 4-6 16m9.5-16-6 16M19.5 4h-10m5 16h-10"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ItalicSquare = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="m14 7-4 10m-2.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Underline02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M19 4v6a7 7 0 1 1-14 0V4m3.5 0v6a7.003 7.003 0 0 0 5.14 6.75M4 21h16M3 4h7.5M17 4h4"
      className="fill-none stroke-current"
    />
  </svg>
);

export const UnderlineSquare = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M15.5 7v3.5a3.5 3.5 0 1 1-7 0V7M8 17h8m-8.2 4h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Strikethrough02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 16a4 4 0 0 0 4 4h4a4 4 0 0 0 0-8m-3.5 8a4 4 0 0 0 0-8M18 8a4 4 0 0 0-4-4h-4a4 4 0 0 0-4 4m7.5-4a4 4 0 0 0-4 4M3 12h18"
      className="fill-none stroke-current"
    />
  </svg>
);

export const StrikethroughSquare = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-current opacity-12"
    />
    <path
      d="M6 12h12m-7 0h2a2.5 2.5 0 0 1 0 5h-2.167a2.334 2.334 0 0 1-2.18-1.5m6.694-7a2.334 2.334 0 0 0-2.18-1.5H11a2.5 2.5 0 0 0-2.292 1.5M7.8 21h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 18.72 21 17.88 21 16.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const TypeStrikethrough01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4 7V6c0-.541.215-1.032.564-1.392M9 20h6m-3-8v8M3 3l18 18M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7m-8-3v2.5"
      className="fill-none stroke-current"
    />
  </svg>
);

export const TypeStrikethrough02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 20h8m-5.75-9.5V20m3.5-6v6M3 3l18 18M4 7V6c0-.541.215-1.032.564-1.392M9.5 4H17c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C20 5.602 20 6.068 20 7m-9.75-3v1m3.5-1v4"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Subscript = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m3 5 10 10m0-10L3 15m18 4h-4c0-1.5.44-2 1.5-2.5S21 15.33 21 14c0-.47-.17-.93-.48-1.29a2.11 2.11 0 0 0-2.62-.44c-.42.24-.74.62-.9 1.07"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Dotpoints02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 5H10m11 14H10m11-7H10M6 5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0 14a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm0-7a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const List = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 12H9m12-6H9m12 12H9m-4-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0-6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm0 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const LeftIndent01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 9.25h-9M21 4H3m18 10.75h-9M21 20H3M4.28 8.56l3.867 2.9c.29.217.434.326.486.459a.5.5 0 0 1 0 .362c-.052.133-.197.242-.486.459l-3.867 2.9c-.412.309-.618.463-.79.46a.5.5 0 0 1-.384-.192C3 15.773 3 15.515 3 15V9.2c0-.515 0-.772.106-.908A.5.5 0 0 1 3.49 8.1c.172-.003.378.151.79.46Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const LeftIndent02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 9.25h-9M21 4h-9m9 10.75H3M21 20H3M4.28 2.96l3.867 2.9c.29.217.434.326.486.459a.5.5 0 0 1 0 .362c-.052.133-.197.242-.486.459l-3.867 2.9c-.412.309-.618.463-.79.46a.5.5 0 0 1-.384-.192C3 10.172 3 9.915 3 9.4V3.6c0-.515 0-.773.106-.908A.5.5 0 0 1 3.49 2.5c.172-.004.378.151.79.46Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const RightIndent01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 4H3m18 16H3m9-10.75H3m9 5.5H3m16.72-6.29-3.867 2.9c-.29.217-.434.326-.486.459a.5.5 0 0 0 0 .362c.052.133.197.242.486.459l3.867 2.9c.412.309.618.463.79.46a.5.5 0 0 0 .384-.192c.106-.136.106-.393.106-.908V9.1c0-.515 0-.772-.106-.908A.5.5 0 0 0 20.51 8c-.172-.003-.378.151-.79.46Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const RightIndent02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 9.25H3M12 4H3m18 10.75H3M21 20H3M19.72 2.96l-3.867 2.9c-.29.217-.434.326-.486.459a.5.5 0 0 0 0 .362c.052.133.197.242.486.459l3.867 2.9c.412.309.618.463.79.46a.5.5 0 0 0 .384-.192C21 10.172 21 9.915 21 9.4V3.6c0-.515 0-.773-.106-.908a.5.5 0 0 0-.384-.192c-.172-.004-.378.151-.79.46Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ImageIndentLeft = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 15.24 11 14.96 11 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 8 9.96 8 9.4 8H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 8.76 3 9.04 3 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 16 4.04 16 4.6 16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21 9.25h-6M21 4H3m18 10.75h-6M21 20H3m1.6-4h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C11 15.24 11 14.96 11 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C10.24 8 9.96 8 9.4 8H4.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C3 8.76 3 9.04 3 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C3.76 16 4.04 16 4.6 16Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ImageIndentRight = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 16 14.04 16 14.6 16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21 4H3m18 16H3M9 9.25H3m6 5.5H3M14.6 16h4.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C21 15.24 21 14.96 21 14.4V9.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C20.24 8 19.96 8 19.4 8h-4.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C13 8.76 13 9.04 13 9.6v4.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C13.76 16 14.04 16 14.6 16Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Edit01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.876 18.116c.046-.414.069-.62.131-.814a2 2 0 0 1 .234-.485c.111-.17.259-.317.553-.61L17 3a2.828 2.828 0 1 1 4 4L7.794 20.206c-.294.294-.442.442-.611.553a2 2 0 0 1-.485.233c-.193.063-.4.086-.814.132L2.5 21.5l.376-3.384Z"
      className="fill-current opacity-12"
    />
    <path
      d="M2.876 18.116c.046-.414.069-.62.131-.814a2 2 0 0 1 .234-.485c.111-.17.259-.317.553-.61L17 3a2.828 2.828 0 1 1 4 4L7.794 20.206c-.294.294-.442.442-.611.553a2 2 0 0 1-.485.233c-.193.063-.4.086-.814.132L2.5 21.5l.376-3.384Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Edit02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.5 21.5l3.384-.376c.414-.046.62-.069.814-.131a2 2 0 0 0 .485-.234c.17-.111.317-.259.61-.553L21 7a2.828 2.828 0 1 0-4-4L3.794 16.206c-.294.294-.442.442-.553.611a2 2 0 0 0-.234.485c-.062.193-.085.4-.131.814L2.5 21.5Z"
      className="fill-current opacity-12"
    />
    <path
      d="m18 10-4-4M2.5 21.5l3.384-.376c.414-.046.62-.069.814-.131a2 2 0 0 0 .485-.234c.17-.111.317-.259.61-.553L21 7a2.828 2.828 0 1 0-4-4L3.794 16.206c-.294.294-.442.442-.553.611a2 2 0 0 0-.234.485c-.062.193-.085.4-.131.814L2.5 21.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Edit03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 20h1.675c.489 0 .733 0 .964-.055.204-.05.399-.13.578-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 0 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 20h9M3 20h1.675c.489 0 .733 0 .964-.055.204-.05.399-.13.578-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 0 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Edit04 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M3 20h1.675c.489 0 .733 0 .964-.055.204-.05.399-.13.578-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 0 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
      className="fill-current opacity-12"
    />
    <path
      d="m21 18-1 1.094A2.71 2.71 0 0 1 18 20c-.75 0-1.47-.326-2-.906a2.716 2.716 0 0 0-2-.904c-.75 0-1.469.325-2 .904M3 20h1.675c.489 0 .733 0 .964-.055.204-.05.399-.13.578-.24.201-.123.374-.296.72-.642L19.5 6.5a2.121 2.121 0 0 0-3-3L3.937 16.063c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.578c-.055.23-.055.475-.055.965V20Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Edit05 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M8 16h1.675c.489 0 .733 0 .963-.055.204-.05.4-.13.579-.24.201-.123.374-.296.72-.642L21.5 5.5a2.121 2.121 0 0 0-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.963V16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M11 4H6.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C2 6.28 2 7.12 2 8.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C4.28 22 5.12 22 6.8 22h8.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C20 19.72 20 18.88 20 17.2V13M8 16h1.675c.489 0 .733 0 .963-.055.204-.05.4-.13.579-.24.201-.123.374-.296.72-.642L21.5 5.5a2.121 2.121 0 0 0-3-3l-9.563 9.563c-.346.346-.519.519-.642.72a2 2 0 0 0-.24.579c-.055.23-.055.474-.055.963V16Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Eraser = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m18 13-7-7m10 15H8m2.937-.937 8.668-8.669c1.189-1.188 1.782-1.782 2.005-2.467a3.001 3.001 0 0 0 0-1.854c-.223-.685-.816-1.279-2.005-2.467l-.211-.212c-1.188-1.188-1.782-1.782-2.467-2.004a3 3 0 0 0-1.854 0c-.686.222-1.28.816-2.468 2.004l-8.211 8.212c-1.188 1.188-1.782 1.782-2.005 2.467a3 3 0 0 0 0 1.854c.223.685.817 1.28 2.005 2.467l.668.669c.346.346.52.519.721.642.179.11.374.19.578.24.23.055.475.055.964.055h1.35c.488 0 .733 0 .963-.055.204-.05.4-.13.578-.24.202-.123.375-.296.72-.642Z"
      className="fill-current opacity-12"
    />
    <path
      d="m18 13-7-7m10 15H8m2.937-.937 8.668-8.669c1.189-1.188 1.782-1.782 2.005-2.467a3.001 3.001 0 0 0 0-1.854c-.223-.685-.816-1.279-2.005-2.467l-.211-.212c-1.188-1.188-1.782-1.782-2.467-2.004a3 3 0 0 0-1.854 0c-.686.222-1.28.816-2.468 2.004l-8.211 8.212c-1.188 1.188-1.782 1.782-2.005 2.467a3 3 0 0 0 0 1.854c.223.685.817 1.28 2.005 2.467l.668.669c.346.346.52.519.721.642.179.11.374.19.578.24.23.055.475.055.964.055h1.35c.488 0 .733 0 .963-.055.204-.05.4-.13.578-.24.202-.123.375-.296.72-.642Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const MagicWand02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15 4V2m0 14v-2M8 9h2m10 0h2m-4.2 2.8L19 13m-1.2-6.8L19 5M3 21l9-9m.2-5.8L11 5"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Brush01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 11.222 12.778 15m-4.803 5.975C6.608 22.342 4 22 2 22c1.025-2-.342-4.608 1.025-5.975a3.5 3.5 0 0 1 4.95 4.95Zm3.947-5.05 9.137-9.868a2.204 2.204 0 0 0-3.116-3.116L8.075 12.08c-.51.472-.765.708-.913.96a2 2 0 0 0-.038 1.967c.139.257.385.503.876.994.491.492.737.737.994.876a2 2 0 0 0 1.968-.038c.251-.148.487-.403.96-.913Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9 11.222 12.778 15m-4.803 5.975C6.608 22.342 4 22 2 22c1.025-2-.342-4.608 1.025-5.975a3.5 3.5 0 0 1 4.95 4.95Zm3.947-5.05 9.137-9.868a2.204 2.204 0 0 0-3.116-3.116L8.075 12.08c-.51.472-.765.708-.913.96a2 2 0 0 0-.038 1.967c.139.257.385.503.876.994.491.492.737.737.994.876a2 2 0 0 0 1.968-.038c.251-.148.487-.403.96-.913Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Brush02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10h12Z"
      className="fill-current opacity-12"
    />
    <path
      d="M18 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C17.24 2 16.96 2 16.4 2H7.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C6 2.76 6 3.04 6 3.6V10m12 0H6m12 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C15.72 15 14.88 15 13.2 15h-2.4c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C6 12.72 6 11.88 6 10.2V10m8.5 5v4.5a2.5 2.5 0 0 1-5 0V15"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Brush03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M20 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C19.24 2 18.96 2 18.4 2H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 2.76 4 3.04 4 3.6V10h16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M20 10V3.6c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C19.24 2 18.96 2 18.4 2H5.6c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C4 2.76 4 3.04 4 3.6V10m16 0H4m16 0v.2c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311C17.72 15 16.88 15 15.2 15H8.8c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C4 12.72 4 11.88 4 10.2V10m10.5 5v4.5a2.5 2.5 0 0 1-5 0V15"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Paint = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m11.5 3 8.868 8.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-5.474 5.475c-1.188 1.188-1.782 1.782-2.467 2.004a3 3 0 0 1-1.854 0c-.685-.222-1.28-.816-2.468-2.004l-3.211-3.212c-1.188-1.188-1.782-1.782-2.005-2.467a3 3 0 0 1 0-1.854c.223-.685.817-1.28 2.005-2.467L11.499 3Z"
      className="fill-current opacity-12"
    />
    <path
      d="M3 13h17m-8-9.5L10.5 2m1 1 8.868 8.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-5.474 5.475c-1.188 1.188-1.782 1.782-2.467 2.004a3 3 0 0 1-1.854 0c-.685-.222-1.28-.816-2.468-2.004l-3.211-3.212c-1.188-1.188-1.782-1.782-2.005-2.467a3 3 0 0 1 0-1.854c.223-.685.817-1.28 2.005-2.467L11.499 3Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PaintPour = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 3l6.868 6.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-4.606 4.606c-.792.792-1.188 1.188-1.644 1.337a2 2 0 0 1-1.236 0c-.457-.149-.853-.545-1.645-1.337l-3.475-3.474c-.792-.792-1.188-1.188-1.336-1.645a2 2 0 0 1 0-1.236c.148-.457.544-.853 1.336-1.645L9 3Z"
      className="fill-current opacity-12"
    />
    <path
      d="M16 11H2m8-7L8 2m6 20H2m20-6a2 2 0 1 1-4 0c0-1.105 2-3 2-3s2 1.895 2 3ZM9 3l6.868 6.869c.396.396.594.594.668.822a1 1 0 0 1 0 .618c-.074.228-.272.426-.668.822l-4.606 4.606c-.792.792-1.188 1.188-1.644 1.337a2 2 0 0 1-1.236 0c-.457-.149-.853-.545-1.645-1.337l-3.475-3.474c-.792-.792-1.188-1.188-1.336-1.645a2 2 0 0 1 0-1.236c.148-.457.544-.853 1.336-1.645L9 3Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const RollerBrush = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M19 4.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C17.197 7 16.965 7 16.5 7h-11c-.465 0-.697 0-.89-.038A2 2 0 0 1 3.038 5.39C3 5.197 3 4.965 3 4.5s0-.697.038-.89A2 2 0 0 1 4.61 2.038C4.803 2 5.035 2 5.5 2h11c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89Z"
      className="fill-current opacity-12"
    />
    <path
      d="M19 4.5c0 .465 0 .697-.038.89a2 2 0 0 1-1.572 1.572C17.197 7 16.965 7 16.5 7h-11c-.465 0-.697 0-.89-.038A2 2 0 0 1 3.038 5.39C3 5.197 3 4.965 3 4.5s0-.697.038-.89A2 2 0 0 1 4.61 2.038C4.803 2 5.035 2 5.5 2h11c.465 0 .697 0 .89.038a2 2 0 0 1 1.572 1.572c.038.193.038.425.038.89Zm0 0c.932 0 1.398 0 1.765.152a2 2 0 0 1 1.083 1.083C22 6.102 22 6.568 22 7.5v.3c0 1.12 0 1.68-.218 2.108a2 2 0 0 1-.874.874C20.48 11 19.92 11 18.8 11h-3.6c-1.12 0-1.68 0-2.108.218a2 2 0 0 0-.874.874C12 12.52 12 13.08 12 14.2v.8m-.4 7h.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437C14 21.24 14 20.96 14 20.4v-3.8c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437C13.24 15 12.96 15 12.4 15h-.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C10 15.76 10 16.04 10 16.6v3.8c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C10.76 22 11.04 22 11.6 22Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Pencil02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m18 2 4 4M2 22l1.276-4.68c.084-.305.125-.458.19-.6.056-.127.126-.247.207-.36.092-.125.204-.237.428-.46L14.434 5.565c.198-.198.297-.297.412-.334a.5.5 0 0 1 .309 0c.114.037.213.136.41.334l2.87 2.868c.197.198.296.297.333.411.033.1.033.21 0 .31-.037.114-.136.213-.334.41L8.101 19.9c-.224.224-.336.336-.462.428a2.003 2.003 0 0 1-.358.208c-.143.064-.296.105-.6.189L2 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="m18 2 4 4M2 22l1.276-4.68c.084-.305.125-.458.19-.6.056-.127.126-.247.207-.36.092-.125.204-.237.428-.46L14.434 5.565c.198-.198.297-.297.412-.334a.5.5 0 0 1 .309 0c.114.037.213.136.41.334l2.87 2.868c.197.198.296.297.333.411.033.1.033.21 0 .31-.037.114-.136.213-.334.41L8.101 19.9c-.224.224-.336.336-.462.428a2.003 2.003 0 0 1-.358.208c-.143.064-.296.105-.6.189L2 22Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PencilLine = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2.5 21.5l2.058-5.351c.147-.383.221-.575.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.434.464.585a.5.5 0 0 1-.08.38c-.089.126-.28.2-.663.347L2.5 21.5Z"
      className="fill-current opacity-12"
    />
    <path
      d="M21 21h-8m-10.5.5 5.55-2.134c.354-.137.532-.205.698-.294.147-.08.288-.171.42-.274.149-.115.283-.25.552-.518L21 7a2.828 2.828 0 1 0-4-4L5.72 14.28c-.269.268-.403.403-.519.552a2.997 2.997 0 0 0-.273.42c-.089.166-.157.344-.294.699L2.5 21.5Zm0 0 2.058-5.351c.147-.383.221-.575.347-.662a.5.5 0 0 1 .38-.08c.15.028.295.173.585.463l2.26 2.26c.29.29.435.434.464.585a.5.5 0 0 1-.08.38c-.089.126-.28.2-.663.347L2.5 21.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PenTool01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m18 13-1.3-6.498c-.072-.363-.108-.545-.197-.692a1 1 0 0 0-.312-.325c-.144-.094-.324-.138-.684-.225L2 2l3.26 13.507c.087.36.13.54.225.684a1 1 0 0 0 .325.312c.147.088.329.125.692.197L13 18l5-5Z"
      className="fill-current opacity-12"
    />
    <path
      d="m18 13-1.3-6.498c-.072-.363-.108-.545-.197-.692a1 1 0 0 0-.312-.325c-.144-.094-.324-.138-.684-.225L2 2m0 0 3.26 13.507c.087.36.13.54.225.684a1 1 0 0 0 .325.312c.147.088.329.125.692.197L13 18M2 2l7.586 7.586m6.545 11.283 4.738-4.738c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822l-.738-.738c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668L13.13 17.87c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l.738.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668ZM13 11a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PenToolMinus = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15 7 8.834 8.76c-.304.088-.457.131-.583.213a1 1 0 0 0-.282.276c-.084.125-.131.276-.224.58L4 22l12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.584L19 11 15 7Z"
      className="fill-current opacity-12"
    />
    <path
      d="M2 5h6m7 2L8.834 8.76c-.304.088-.457.131-.583.213a1 1 0 0 0-.282.276c-.084.125-.131.276-.224.58L4 22m0 0 12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.584L19 11M4 22l6.586-6.586m11.283-7.546L18.13 4.131c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.737c-.396.396-.594.595-.668.823a1 1 0 0 0 0 .618c.074.228.272.426.668.822l3.738 3.737c.396.396.594.595.822.669a1 1 0 0 0 .618 0c.228-.075.426-.273.822-.669l.738-.737c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.229-.272-.427-.668-.823ZM12 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PenToolPlus = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15 7 8.834 8.762c-.304.087-.457.13-.583.212a1 1 0 0 0-.282.277c-.084.124-.131.275-.224.578L4 22l12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.583L19 11 15 7Z"
      className="fill-current opacity-12"
    />
    <path
      d="M15 7 8.834 8.762c-.304.087-.457.13-.583.212a1 1 0 0 0-.282.277c-.084.124-.131.275-.224.578L4 22m0 0 12.17-3.745c.304-.093.455-.14.58-.224a1 1 0 0 0 .276-.282c.082-.126.125-.279.212-.583L19 11M4 22l6.586-6.586M5 8V2M2 5h6m13.869 2.869L18.13 4.13c-.396-.396-.594-.594-.822-.668a1 1 0 0 0-.618 0c-.228.074-.426.272-.822.668l-.738.738c-.396.396-.594.594-.668.822a1 1 0 0 0 0 .618c.074.228.272.426.668.822l3.738 3.738c.396.396.594.594.822.668a1 1 0 0 0 .618 0c.228-.074.426-.272.822-.668l.738-.738c.396-.396.594-.594.668-.822a1 1 0 0 0 0-.618c-.074-.228-.272-.426-.668-.822ZM12 12a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Cursor01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m17.964 10.751-5.01 1.702c-.138.047-.206.07-.263.109a.502.502 0 0 0-.129.129c-.04.057-.062.125-.109.262l-1.702 5.011c-.21.621-.316.932-.481 1.026a.5.5 0 0 1-.465.016c-.171-.083-.297-.386-.55-.992L3.747 4.794c-.234-.563-.351-.844-.294-1.02a.5.5 0 0 1 .321-.321c.176-.057.457.06 1.02.294l13.22 5.508c.606.253.909.379.992.55a.5.5 0 0 1-.016.465c-.094.165-.405.27-1.026.481Z"
      className="fill-current opacity-12"
    />
    <path
      d="m13 13 6 6m-1.036-8.249-5.01 1.702c-.138.047-.206.07-.263.109a.502.502 0 0 0-.129.129c-.04.057-.062.125-.109.262l-1.702 5.011c-.21.621-.316.932-.481 1.026a.5.5 0 0 1-.465.016c-.171-.083-.297-.386-.55-.992L3.747 4.794c-.234-.563-.351-.844-.294-1.02a.5.5 0 0 1 .321-.321c.176-.057.457.06 1.02.294l13.22 5.508c.606.253.909.379.992.55a.5.5 0 0 1-.016.465c-.094.165-.405.27-1.026.481Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Cursor03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.712 3.674c-.541-.212-.811-.319-.984-.262a.5.5 0 0 0-.316.317c-.057.172.049.442.262.983l5.3 13.456c.172.435.258.652.398.74a.5.5 0 0 0 .408.055c.158-.047.298-.234.579-.609l2.14-2.854 3.45 4.743c.19.26.284.391.405.446a.5.5 0 0 0 .338.026c.128-.035.242-.149.47-.377l3.176-3.176c.227-.228.341-.342.377-.47a.5.5 0 0 0-.027-.337c-.054-.121-.185-.216-.446-.406L15.5 12.5l2.854-2.14c.374-.281.561-.422.608-.58a.5.5 0 0 0-.055-.408c-.087-.14-.305-.225-.74-.397l-13.455-5.3Z"
      className="fill-current opacity-12"
    />
    <path
      d="M4.712 3.674c-.541-.212-.811-.319-.984-.262a.5.5 0 0 0-.316.317c-.057.172.049.442.262.983l5.3 13.456c.172.435.258.652.398.74a.5.5 0 0 0 .408.055c.158-.047.298-.234.579-.609l2.14-2.854 3.45 4.743c.19.26.284.391.405.446a.5.5 0 0 0 .338.026c.128-.035.242-.149.47-.377l3.176-3.176c.227-.228.341-.342.377-.47a.5.5 0 0 0-.027-.337c-.054-.121-.185-.216-.446-.406L15.5 12.5l2.854-2.14c.374-.281.561-.422.608-.58a.5.5 0 0 0-.055-.408c-.087-.14-.305-.225-.74-.397l-13.455-5.3Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Cursor04 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M4.407 3.414c-.458-.135-.687-.202-.843-.144a.5.5 0 0 0-.294.294c-.058.156.009.385.144.843l4.206 14.3c.125.426.188.64.314.738a.5.5 0 0 0 .39.1c.158-.027.315-.184.629-.498L12 16l4.434 4.434c.198.198.297.297.411.335a.5.5 0 0 0 .31 0c.114-.037.213-.136.41-.334l2.87-2.87c.197-.197.296-.296.333-.41a.5.5 0 0 0 0-.31c-.037-.113-.136-.212-.334-.41L16 12l3.047-3.047c.314-.314.47-.47.497-.629a.5.5 0 0 0-.1-.39c-.098-.126-.311-.189-.737-.314l-14.3-4.206Z"
      className="fill-current opacity-12"
    />
    <path
      d="M4.407 3.414c-.458-.135-.687-.202-.843-.144a.5.5 0 0 0-.294.294c-.058.156.009.385.144.843l4.206 14.3c.125.426.188.64.314.738a.5.5 0 0 0 .39.1c.158-.027.315-.184.629-.498L12 16l4.434 4.434c.198.198.297.297.411.335a.5.5 0 0 0 .31 0c.114-.037.213-.136.41-.334l2.87-2.87c.197-.197.296-.296.333-.41a.5.5 0 0 0 0-.31c-.037-.113-.136-.212-.334-.41L16 12l3.047-3.047c.314-.314.47-.47.497-.629a.5.5 0 0 0-.1-.39c-.098-.126-.311-.189-.737-.314l-14.3-4.206Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const CursorBox = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M21 9.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h1.7"
      className="fill-current opacity-12"
    />
    <path
      d="M21 9.5V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8v8.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C5.28 21 6.12 21 7.8 21h1.7m7.886-3.289-1.698 3.154c-.278.516-.417.774-.586.84a.5.5 0 0 1-.447-.038c-.155-.096-.247-.374-.43-.93L11.5 12.511c-.16-.486-.241-.73-.183-.892a.5.5 0 0 1 .302-.302c.162-.058.405.022.892.183l8.226 2.724c.556.184.834.276.93.431a.5.5 0 0 1 .039.447c-.067.17-.325.308-.84.586l-3.155 1.698a1.062 1.062 0 0 0-.152.09.508.508 0 0 0-.082.083 1.062 1.062 0 0 0-.09.152Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const CursorClick02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="m8.5 8.5 4.111 12.778 2.889-2.89L19.111 22 22 19.111 18.389 15.5l2.889-2.889L8.5 8.5Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9 3.5V2M5.06 5.06 4 4m1.06 9L4 14.06m9-9L14.06 4M3.5 9H2m6.5-.5 4.111 12.778 2.889-2.89L19.111 22 22 19.111 18.389 15.5l2.889-2.889L8.5 8.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Scissors02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M4.5 8.6 21 17m0-10L4.5 15.4M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ScissorsCut01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M20 4 8.5 15.5m0-7L20 20m-2.5-8h.01M22 12h.01M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ScissorsCut02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-current opacity-12"
    />
    <path
      d="M4.5 8.6 21 17m0-10L4.5 15.4m13-3.4h.01M22 12h.01M6 3a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 12a3 3 0 1 1 0 6 3 3 0 0 1 0-6Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Crop01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2 6h12.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V22m4-4H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V2"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Crop02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M10 6h4.8c1.12 0 1.68 0 2.108.218a2 2 0 0 1 .874.874C18 7.52 18 8.08 18 9.2V14M2 6h4m12 12v4m4-4H9.2c-1.12 0-1.68 0-2.108-.218a2 2 0 0 1-.874-.874C6 16.48 6 15.92 6 14.8V2"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Reflect02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 3v3m0 4.5v3m0 4.5v3m10-9h-6.5m0 0 4 4m-4-4 4-4M2 12h6.5m0 0-4 4m4-4-4-4"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Colors1 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 20.472a6 6 0 1 0 5.58-10.262m-11.16 0a6 6 0 1 0 7.16 3.58M18 8A6 6 0 1 1 6 8a6 6 0 0 1 12 0Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Droplets01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M22 16a6 6 0 0 1-12 0c0-4.314 6-14 6-14s6 9.686 6 14ZM8 9a3 3 0 1 1-6 0c0-2.157 3-7 3-7s3 4.843 3 7Z"
      className="fill-current opacity-12"
    />
    <path
      d="M22 16a6 6 0 0 1-12 0c0-4.314 6-14 6-14s6 9.686 6 14ZM8 9a3 3 0 1 1-6 0c0-2.157 3-7 3-7s3 4.843 3 7Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Droplets02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 21.5a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5C11.5 5 10 7.4 8 9c-2 1.6-3 3.5-3 5.5a7 7 0 0 0 7 7Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 21.5a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-3.5-4-4-6.5C11.5 5 10 7.4 8 9c-2 1.6-3 3.5-3 5.5a7 7 0 0 0 7 7Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Droplets03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12.56 6.08A10.97 10.97 0 0 0 14 2.5c.5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97M7 15.78c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19-1.14-.93-2-2.31-2.29-3.76a6.585 6.585 0 0 1-2.29 3.76C3.56 9.46 3 10.58 3 11.73c0 2.22 1.8 4.05 4 4.05Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12.56 6.08A10.97 10.97 0 0 0 14 2.5c.5 2.5 2 4.9 4 6.5 2 1.6 3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97M7 15.78c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19-1.14-.93-2-2.31-2.29-3.76a6.585 6.585 0 0 1-2.29 3.76C3.56 9.46 3 10.58 3 11.73c0 2.22 1.8 4.05 4 4.05Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const ZoomIn = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16Z"
      className="fill-current opacity-12"
    />
    <path
      d="m21 21-4.35-4.35M11 8v6m-3-3h6m5 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0Z"
      className="fill-none stroke-current [stroke-linecap:round] [stroke-linejoin:round] stroke-[1.8]"
    />
  </svg>
);
